module.exports = __webpack_public_path__ + "img/STX.a7c349ba.svg";